import * as React from "react";
import type { ComponentType } from "react";

export const withReactStrict: <T extends ComponentType<any>>(
	Component: T,
) => (props: React.ComponentProps<T>) => React.ReactNode = (Component) =>
	function renderStrict(props) {
		return (
			<React.StrictMode>
				<Component {...props} />
			</React.StrictMode>
		);
	};
